let Check = function (props) {
  let {
    checked,
    onCheck,
    label,
    size = "big",
    shape = "circle"
  } = props;

  let onChange = function (evt) {
    onCheck(evt.target.checked);
  };

  return (
    <label className="mc-check" data-size={size} data-shape={shape}>
      <input type="checkbox" checked={checked} onChange={onChange}/>
      <span>{label}</span>
    </label>
  );
};

module.exports = Check;